import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clientQuery } from "#modules/clients/infra/client.query";
import { clientsQuery } from "#modules/clients/infra/clients.query";
import { updateContact } from "#modules/contacts/infra/updateContact.api";
import { quoteRequestsQuery } from "#modules/quoteRequests/infra/quoteRequests.query";

import { contactQuery } from "../infra/contact.query";

export const useUpdateContact = ({
  clientId,
  contactId,
}: {
  contactId: string | undefined | null;
  clientId: string | undefined | null;
}) => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: updateContact,
    onSuccess: () => {
      void queryClient.invalidateQueries(quoteRequestsQuery());
      void queryClient.invalidateQueries(clientQuery(clientId || ""));
      void queryClient.invalidateQueries(clientsQuery());
      void queryClient.invalidateQueries(contactQuery(contactId || ""));
    },
  });

  return { updateContact: mutate, updateContactAsync: mutateAsync, ...rest };
};
